import PageView from "@/views/Page.vue";
export const approvalRouter = {
  path: "/approval",
  redirect: {
    name: "approvalManage"
  },
  component: PageView,
  children: [
    {
      path: "index",
      name: "approvalIndex",
      component: () => import("@/views/approval/index.vue"),
      meta: {
        title: "区域选择"
      }
    }
  ]
};
